export const BeachImages =[
    {
        id:1,
        url:"https://images.pexels.com/photos/3233371/pexels-photo-3233371.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        text:"1. Radhanagar Beach- Havelock Island, Andaman and Nicobar Islands",
        Info:"With some of the finest beaches of the country in its arms, Andaman and Nicobar Islands is best known for its pristine surroundings and untouched natural beauty. The Radhanagar Beach on the Havelock Island is the most popular tourist attraction of Andaman and Nicobar Island. It has been bestowed with the precious ‘Asia’s best beach’ award by Time Magazine.",
        label:'see details',
        btn:'Book Now',
        path:'/beach/1',
        
    },
    {
        id:2,
        url:"https://images.pexels.com/photos/2932486/pexels-photo-2932486.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        text:"2. Agonda Beach – Goa",
        label:'see details',
        btn:'Book Now',
        Info:"Agonda Beach is an isolated stretch of sea line located on the outskirts of Goa that helps you to relax amid natural wonders like soft warm sand and turquoise blue water. It has plenty of beach side accommodations, mostly huts for tourists to relax and enjoy the stillness of nature. Agonda is gaining popularity lately and a lot of hotels, souvenir stalls, and restaurants are coming up on site. It is undoubtedly one of the best beaches of Goa to visit in India.",
        path:'/beach/2',

    },
    {
        id:3,
        url:"https://images.pexels.com/photos/1732412/pexels-photo-1732412.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        text:"3. Ullal Beach – Mangalore",
        Info:"Ullal Beach is one of the best beaches in Mangalore for beach holidays in India. It is a fishing village located on the southern banks of Netravali River. It is not a crowded beach. Apart from the other beaches in Mangalore, it gives peaceful vibes to the tourists who come to rejuvenate their spirit. Coconut trees, scenic sand, tranquil surroundings and less crowd makes Ullal beach, the best beach getaway in India.",
        label:'see details',
        btn:'Book Now',
        path:'/beach/3',
        
    },
]